import { APIError } from '../types/response';
import {
  RESPONSE_HTTP_NON_SUCCESS,
  RESPONSE_STATUS_FAIL,
  RESPONSE_STATUS_POLL,
  RESPONSE_STATUS_SUCCESS,
} from './auth-errors';
import { NOOP } from './defaults';

interface Response {
  status?: string;
  httpStatus?: string;
  httpStatusText?: string;
}

type Callback<T> = (response: T) => void;

// TODO: KU – simplify this + useAuthRequestCallbacks
export function authRequest<R extends Response>({
  url,
  requestBody = null,
  onAuthFailure = NOOP,
  onAuthSuccess,
  onError,
  onPreRequest = NOOP,
  onResponse = NOOP,
}: {
  url: string;
  requestBody?: string | null;
  onAuthFailure?: Callback<R>;
  onAuthSuccess: Callback<R>;
  onError: Callback<APIError>;
  onPreRequest?: VoidFunction;
  onResponse?: VoidFunction;
}) {
  onPreRequest?.();

  fetch(url, {
    method: 'POST',
    body: requestBody,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  })
    .then(response => {
      onResponse?.();
      if (response.ok) {
        return response.json();
      }

      return {
        status: RESPONSE_HTTP_NON_SUCCESS,
        httpStatus: response.status,
        httpStatusText: response.statusText,
      };
    })
    .then((response: R) => {
      const { status } = response;

      if (status === RESPONSE_STATUS_SUCCESS) {
        onAuthSuccess(response);
      } else if (status === RESPONSE_STATUS_FAIL || status === RESPONSE_STATUS_POLL) {
        onAuthFailure?.(response);
      } else if (status === RESPONSE_HTTP_NON_SUCCESS) {
        const error = {
          name: `Status code: ${response.httpStatus}`,
          description: `${response.httpStatusText}`,
        };
        onError(error);
      } else {
        const error = {
          name: 'Unrecognized response status',
          description: `Response status: ${status}`,
        };
        onError(error);
      }
    })
    .catch(networkError => {
      onResponse?.();
      const error = {
        name: networkError.name,
        description: networkError.message,
      };
      onError(error);
    });
}
